/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlFileMetadataVersionInfo } from './ControlFileMetadataVersionInfo';
import {
    ControlFileMetadataVersionInfoFromJSON,
    ControlFileMetadataVersionInfoFromJSONTyped,
    ControlFileMetadataVersionInfoToJSON,
} from './ControlFileMetadataVersionInfo';
import type { ControlThreatName } from './ControlThreatName';
import {
    ControlThreatNameFromJSON,
    ControlThreatNameFromJSONTyped,
    ControlThreatNameToJSON,
} from './ControlThreatName';

/**
 * 
 * @export
 * @interface ControlFileMetadata
 */
export interface ControlFileMetadata {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlFileMetadata
     */
    fileNameCatalogMatches: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlFileMetadata
     */
    lastScanTime: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlFileMetadata
     */
    proposedFileNames: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlFileMetadata
     */
    story?: string;
    /**
     * 
     * @type {Array<ControlThreatName>}
     * @memberof ControlFileMetadata
     */
    threatNames: Array<ControlThreatName>;
    /**
     * 
     * @type {Array<ControlFileMetadataVersionInfo>}
     * @memberof ControlFileMetadata
     */
    versionInfo: Array<ControlFileMetadataVersionInfo>;
}

/**
 * Check if a given object implements the ControlFileMetadata interface.
 */
export function instanceOfControlFileMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileNameCatalogMatches" in value;
    isInstance = isInstance && "lastScanTime" in value;
    isInstance = isInstance && "proposedFileNames" in value;
    isInstance = isInstance && "threatNames" in value;
    isInstance = isInstance && "versionInfo" in value;

    return isInstance;
}

export function ControlFileMetadataFromJSON(json: any): ControlFileMetadata {
    return ControlFileMetadataFromJSONTyped(json, false);
}

export function ControlFileMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlFileMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileNameCatalogMatches': json['fileNameCatalogMatches'],
        'lastScanTime': json['lastScanTime'],
        'proposedFileNames': json['proposedFileNames'],
        'story': !exists(json, 'story') ? undefined : json['story'],
        'threatNames': ((json['threatNames'] as Array<any>).map(ControlThreatNameFromJSON)),
        'versionInfo': ((json['versionInfo'] as Array<any>).map(ControlFileMetadataVersionInfoFromJSON)),
    };
}

export function ControlFileMetadataToJSON(value?: ControlFileMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileNameCatalogMatches': value.fileNameCatalogMatches,
        'lastScanTime': value.lastScanTime,
        'proposedFileNames': value.proposedFileNames,
        'story': value.story,
        'threatNames': ((value.threatNames as Array<any>).map(ControlThreatNameToJSON)),
        'versionInfo': ((value.versionInfo as Array<any>).map(ControlFileMetadataVersionInfoToJSON)),
    };
}

